<template>
  <div class="container-fluid">
    <p><router-link :to="{name: 'ChannelAmazonProductList'}">Zurück zur Amazon-Artikel-Liste</router-link></p>
    <textarea id="shoutbox" v-model="excelText">Z_1003.11188_B2	99.90	1	B008V25F36	ASIN	Refurbished	Neues und unbenutztes Ausstellungsgerät in einwandfreiem Zustand, vollständiger Lieferumfang, Ware wurde noch nicht in Betrieb genommen</textarea>
    <button class="btn btn-large btn-success" v-on:click="sendDataToParse" :disabled="excelText.length == 0">{{excelText.length > 0 ? "Text parsen" : "Bitte SKUs aus Excel hier per Copy&Paste einfügen"}}</button>
    <br/>
    <img v-show="loadingData" width="3%" src="../assets/spinner.gif">
    <br/>
    <div v-show="parsedData.length > 0">
      <table class="table table-bordered table-sm">
        <thead>
          <th>SKU</th>
          <th>Price</th>
          <th>Quantity</th>
          <th>Product ID</th>
          <th>Product ID Type</th>
          <th>Condition Type</th>
          <th>Condition Note</th>
          <th>Vorhanden in CXA?</th>
        </thead>
        <tbody>
          <tr v-for="row in parsedData">
            <td v-bind:class="{ 'field-not-valid': row.fields.sku.valid == false}" data-toggle="tooltip" data-placement="top" :title="row.fields.sku.message"><span>{{row.fields.sku.value}}</span></td>
            <td v-bind:class="{ 'field-not-valid': row.fields.price.valid == false, existsAndEqual: row.fields.price.ccsInfo && row.fields.price.ccsInfo.equal == true, existsAndDifferent: row.fields.price.ccsInfo && row.fields.price.ccsInfo.equal == false}" data-toggle="tooltip" data-placement="top" :title="row.fields.price.message"><span>{{row.fields.price.value}}</span></td>
            <td v-bind:class="{ 'field-not-valid': row.fields.quantity.valid == false, existsAndEqual: row.fields.quantity.ccsInfo && row.fields.quantity.ccsInfo.equal == true, existsAndDifferent: row.fields.quantity.ccsInfo && row.fields.quantity.ccsInfo.equal == false}" data-toggle="tooltip" data-placement="top" :title="row.fields.quantity.message"><span>{{row.fields.quantity.value}}</span></td>
            <td v-bind:class="{ 'field-not-valid': row.fields.productId.valid == false, existsAndEqual: row.fields.productId.ccsInfo && row.fields.productId.ccsInfo.equal == true, existsAndDifferent: row.fields.productId.ccsInfo && row.fields.productId.ccsInfo.equal == false}" data-toggle="tooltip" data-placement="top" :title="row.fields.productId.message"><span>{{row.fields.productId.value}}</span></td>
            <td v-bind:class="{ 'field-not-valid': row.fields.productIdType.valid == false, existsAndEqual: row.fields.productIdType.ccsInfo && row.fields.productIdType.ccsInfo.equal == true, existsAndDifferent: row.fields.productIdType.ccsInfo && row.fields.productIdType.ccsInfo.equal == false}" data-toggle="tooltip" data-placement="top" :title="row.fields.productIdType.message"><span>{{row.fields.productIdType.value}}</span></td>
            <td v-bind:class="{ 'field-not-valid': row.fields.conditionType.valid == false, existsAndEqual: row.fields.conditionType.ccsInfo && row.fields.conditionType.ccsInfo.equal == true, existsAndDifferent: row.fields.conditionType.ccsInfo && row.fields.conditionType.ccsInfo.equal == false}" data-toggle="tooltip" data-placement="top" :title="row.fields.conditionType.message"><span>{{row.fields.conditionType.value}}</span></td>
            <td v-bind:class="{ 'field-not-valid': row.fields.conditionNote.valid == false, existsAndEqual: row.fields.conditionNote.ccsInfo && row.fields.conditionNote.ccsInfo.equal == true, existsAndDifferent: row.fields.conditionNote.ccsInfo && row.fields.conditionNote.ccsInfo.equal == false}" data-toggle="tooltip" data-placement="top" :title="row.fields.conditionNote.message"><span>{{row.fields.conditionNote.value}}</span></td>
            <td>{{row.ccsInfo.exists ? "Ja" : "Nein"}}</td>
          </tr>
        </tbody>
      </table>
      <br/>
      <div class="alert alert-danger" role="alert"v-if="containsErrors">Es sind Fehler vorhanden, der Upload kann daher nicht durchgeführt werden. Bitte beseitigen Sie den Fehler, bevor Sie fortfahren.</div>
      <button class="btn btn-large btn-success" v-on:click="uploadData" :disabled="!readyToUpload">{{readyToUpload ? "Upload" : "Bitte Fehler beseitigen"}}</button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'SkuExcelUpload',
  props:[],
  data () {
    return {
      excelText: '',
      parsedData: [],
      loadingData: false,
      readyToUpload: false,
      containsErrors: false,
    }
  },
  mounted: function () {
  },

  updated: function() {
    $('[data-toggle="tooltip"]').tooltip();
  },

  methods: {
    sendDataToParse: function() {
      this.loadingData = true;
      fetch("https://07s1fhg37a.execute-api.eu-central-1.amazonaws.com/prod/sku/excel", {
        method: 'POST',
        body: this.excelText,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.token
        },
      })
        .then(response => {
          if (response.status === 401) {
            delete localStorage.token;
            delete localStorage.username;
            delete localStorage.name;
            delete localStorage.email;
            this.$router.push('/login?redirect=' + this.$route.path);
          }
          return response.json();
        })
        .then((data) => {
          this.parsedData = data;
          this.loadingData = false;
          this.updateUploadReadiness();
        })
        .catch((err) => {
          console.log(err)
          this.loadingData = false;
        });
    },

    uploadData: function() {
      this.loadingData = true;
      fetch("https://07s1fhg37a.execute-api.eu-central-1.amazonaws.com/prod/sku", {
        method: 'POST',
        body: this.getUploadPayload(),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.token
        },
      })
        .then(response => {
          if (response.status === 401) {
            delete localStorage.token;
            delete localStorage.username;
            delete localStorage.name;
            delete localStorage.email;
            this.$router.push('/login?redirect=' + this.$route.path);
          }
          if (response.status > 401) {
            throw new Exception();
          }
          return response.json();
        })
        .then((data) => {
          this.sendDataToParse();
          this.loadingData = false;
          toastr.success('<table padding="15px"><tr><td>Neu angelegt:</td><td style:"text-align:left">'+data.newItems+'</td></tr><tr><td>Aktualisiert:</td><td>'+data.updatedItems+'</td></tr><tr><td>Unverändert:</td><td>'+data.unchangedItems+'</td></tr><tr><td>Fehler:</td><td>'+data.errors+'</td></tr></table>', 'Ergebnisse', {timeOut: 20000, closeButton: true});
        })
        .catch((err) => {
          console.log(err)
          this.loadingData = false;
          toastr.error('Die Änderungen konnten nicht gespeichert werden. Bitte versuchen Sie es noch einmal. Falls das Problem wieder auftritt, informieren Sie bitte den Administrator.');
        });
    },

    updateUploadReadiness: function() {
      if (this.parsedData == null || this.parsedData.length == 0) {
        this.readyToUpload = false;
        return;
      }

      var atLeastOneError = false;
      var allGood = true;

      for (var x=0; x<this.parsedData.length; x++) {
        var row = this.parsedData[x];
        console.log(row.ccsInfo.exists);
        if ( (row.ccsInfo.exists === false) && (!(row.fields.sku.valid && row.fields.price.valid && row.fields.quantity.valid && row.fields.productId.valid && row.fields.productIdType.valid && row.fields.conditionType.valid && row.fields.conditionNote.valid))) {
          console.log("error");
          atLeastOneError = true;
        };
        if ( (row.ccsInfo.exists === false) && (!(row.fields.sku.valid && row.fields.price.valid && row.fields.quantity.valid && row.fields.productId.valid && row.fields.productIdType.valid && row.fields.conditionType.valid && row.fields.conditionNote.valid))) {
          console.log("Hallo");
          allGood = false;
        };
      }

      this.readyToUpload = allGood;
      this.containsErrors = atLeastOneError;
    },

    getUploadPayload: function() {
      var result = [];
      for (var x=0; x<this.parsedData.length; x++) {
        var row = this.parsedData[x];
        var item = {};
        item.sku = row.fields.sku.value;
        item.price = Number(row.fields.price.value);
        item.quantity = Number(row.fields.quantity.value);
        item.productId = row.fields.productId.value;
        item.productIdType = row.fields.productIdType.value;
        item.conditionType = row.fields.conditionType.value;
        item.conditionNote = row.fields.conditionNote.value;
        result.push(item);
      }
      console.log(JSON.stringify(result));
      return JSON.stringify(result);
    }
  },
}
</script>


<style scoped>
textarea {
  width: 100%;
  height: 20vw;
}
.field-not-valid {
  background-color:#ef8787;
}
.exists {
  text-decoration: line-through;
  background-color:#dddddd !important;
}
.existsAndEqual {
  background-color: #0bf10b;
}
.existsAndDifferent {
  background-color: red;
}
</style>
